// Paths relative to the router basename, so they hold under /en too.
// scripts/build-sites.js writes a static copy of index.html for each of them.
export const HOME_PATH = '/';
export const PROJECTS_PATH = '/projekty/';
export const WEBSITES_PATH = '/strony-internetowe/';
export const AUTOMATION_PATH = '/automatyzacje-ai/';
